import React, { useContext, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';

import './ScrollableSports.scss';
import { RootState, Dispatch } from '../../../configs/store';
import SportsBettingContext from '../../SportsBetting/Context/SportsBetting.context';
import Icon from 'src/components/Icon/Icon';

function ScrollableSports() {
  const { selectedSport, setSelectedSport } = useContext(SportsBettingContext);
  const { t } = useTranslation('common');
  const history = useHistory();

  const { availableSports } = useSelector((state: RootState) => state.events);
  const dispatch = useDispatch<Dispatch>();

  const toggleSelectedSport = (sport) => e => {
    e.preventDefault();

    setSelectedSport(selectedSport === sport.id ? null : sport.id);
  };

  useLayoutEffect(() => {
    dispatch.events.getAvailableSports();
  }, []);

  useLayoutEffect(() => {
    if (_.isNull(selectedSport)) {
      dispatch.events.getSportEventsList([]);
    } else {
      dispatch.events.getSportEventsListBySport(selectedSport);
    }
  }, [selectedSport]);

  return (
    <div className="scrollable-sports">
      <div className="scrollable-sports__sport scrollable-sports__sport--page" onClick={ () => history.push('/racing/today') }>
        <div className="scrollable-sports__icon">
          <Icon icon="horses" />
        </div>
        <div className="scrollable-sports__title">{ t('scrollableSports.horses') }</div>
      </div>
      <div className="scrollable-sports__sport scrollable-sports__sport--page" onClick={ () => history.push('/lotto') }>
        <div className="scrollable-sports__icon">
          <Icon icon="numberIcon" />
        </div>
        <div className="scrollable-sports__title">{ t('scrollableSports.lotto') }</div>
      </div>
      {
        _.map(availableSports, (sport) =>
          <div
            key={ sport.id + sport.name }
            className={ classNames('scrollable-sports__sport', { 'scrollable-sports__sport--selected': selectedSport === sport.id }) }
            onClick={ toggleSelectedSport(sport) }
          >
            <div className="scrollable-sports__icon sport-icon">{ sport.icon ? sport.icon : 'a' }</div>
            <div className="scrollable-sports__title">{ sport.name }</div>
          </div>
        )
      }
    </div>
  );
}

export default ScrollableSports;
